/**
 * @module plugins/modal
 */
import { Plugin } from '@roskvartal-landings/base';
import { Modal } from '@roskvartal-landings/component-modal';

/**
 * @inheritdoc
 * @description Плагин для модальных окон
 * @hideconstructor
 * @example
 * <!-- Откроет модальное окно с идентификатором #leadModal -->
 * <button data-modal="#leadModal">
 *  Открыть модальное окно
 * </button>
 */
class ModalPlugin extends Plugin {
  /**
   * @description Добавляет обработчик события <code>click</code> для каждого элемента
   * с атрибутом <code>data-modal</code>, вызывающий событие
   * {@link module:components/modal~Modal.openEvent}
   */
  static init() {
    const elements = [...document.querySelectorAll('[data-modal]')];
    elements.forEach((element) => {
      const { modal, payload } = element.dataset;
      const modalElement = document.querySelector(modal);
      element.addEventListener('click', () => {
        try {
          modalElement.dispatchEvent(Modal.getCustomOpenEvent(JSON.parse(payload)));
        }
        catch (e) {
          modalElement.dispatchEvent(Modal.openEvent);
        }
      });
    });
  }
}
ModalPlugin.config = {};

export default ModalPlugin;
